import React from 'react';

interface QuickFunctionActionsProps {
    onVoiceRecord: () => void;
    onCameraCapture: () => void;
    onFileUpload: () => void;
    onScheduleMeeting: () => void;
    onClose: () => void;
    isVoiceRecording: boolean;
    voiceConnectionStatus: string;
    isCameraLoading: boolean;
}

const QuickFunctionActions: React.FC<QuickFunctionActionsProps> = ({
    onVoiceRecord,
    onCameraCapture,
    onFileUpload,
    onScheduleMeeting,
    onClose,
    isVoiceRecording,
    voiceConnectionStatus,
    isCameraLoading
}) => {
    const handleAction = (action: () => void) => {
        onClose();
        action();
    };

    const getVoiceStatus = () => {
        if (isVoiceRecording) return '录音中...';
        switch (voiceConnectionStatus) {
            case 'connected':
                return '已连接，点击开始录音';
            case 'recording':
                return '正在录音并转换文字';
            case 'error':
                return '连接错误，点击重试';
            default:
                return '实时语音转文字';
        }
    };

    const functions = [
        {
            id: 'voice-record',
            icon: '🎤',
            title: isVoiceRecording ? '录音中...' : '语音录入',
            description: getVoiceStatus(),
            action: () => handleAction(onVoiceRecord),
            bgColor: isVoiceRecording ? 'bg-red-200 animate-pulse' : 'bg-red-100'
        },
        {
            id: 'file-upload',
            icon: '📎',
            title: '发送附件',
            description: '上传文档、图片等文件',
            action: () => handleAction(onFileUpload),
            bgColor: 'bg-blue-100'
        },
        {
            id: 'camera-capture',
            icon: '📷',
            title: isCameraLoading ? '正在启动相机...' : '拍照发送',
            description: isCameraLoading ? '请稍候' : '使用相机拍摄照片',
            action: () => handleAction(onCameraCapture),
            bgColor: 'bg-green-100'
        },
        {
            id: 'schedule-meeting',
            icon: '📅',
            title: '安排会议',
            description: '创建会议邀请和日程',
            action: () => handleAction(onScheduleMeeting),
            bgColor: 'bg-purple-100'
        }
    ];

    return (
        <div className="space-y-3">
            {functions.map((func) => (
                <button
                    key={func.id}
                    onClick={func.action}
                    className="w-full flex items-center space-x-4 p-4 bg-gray-50 rounded-xl hover:bg-gray-100 transition-colors text-left"
                >
                    <div className={`w-12 h-12 ${func.bgColor} rounded-full flex items-center justify-center`}>
                        <span className="text-xl">{func.icon}</span>
                    </div>
                    <div>
                        <p className="font-medium text-gray-900">{func.title}</p>
                        <p className="text-sm text-gray-500">{func.description}</p>
                    </div>
                </button>
            ))}
        </div>
    );
};

export default QuickFunctionActions;
